var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrowseCompareVendor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 48 48",
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m45.4140625 42.5859375-14.7907104-14.7907104c2.1078491-2.7102051 3.3766479-6.1038819 3.3766479-9.7952271 0-8.8222656-7.1777344-16-16-16s-16 7.1777344-16 16 7.1777344 16 16 16c3.6913452 0 7.085022-1.2687988 9.7952271-3.3766479l14.7907104 14.7907104c.390625.390625.9023438.5859375 1.4140625.5859375s1.0234375-.1953125 1.4140625-.5859375c.78125-.7807617.78125-2.0473633 0-2.828125z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m45.4140625 42.5859375-14.7907104-14.7907104c2.1078491-2.7102051 3.3766479-6.1038819 3.3766479-9.7952271 0-8.8222656-7.1777344-16-16-16s-16 7.1777344-16 16 7.1777344 16 16 16c3.6913452 0 7.085022-1.2687988 9.7952271-3.3766479l14.7907104 14.7907104c.390625.390625.9023438.5859375 1.4140625.5859375s1.0234375-.1953125 1.4140625-.5859375c.78125-.7807617.78125-2.0473633 0-2.828125zm-39.4140625-24.5859375c0-6.6166992 5.3828125-12 12-12s12 5.3833008 12 12-5.3828125 12-12 12-12-5.3833008-12-12z",
    fill: "#09f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowseCompareVendor);
export default __webpack_public_path__ + "static/media/browse-compare-vendor.f84f64e65fd431b6ee6a872d6eda7fdc.svg";
export { ForwardRef as ReactComponent };